import { render, staticRenderFns } from "./CoordinateAppointment.vue?vue&type=template&id=5bb80c8a&scoped=true"
import script from "./CoordinateAppointment.vue?vue&type=script&lang=js"
export * from "./CoordinateAppointment.vue?vue&type=script&lang=js"
import style0 from "./CoordinateAppointment.vue?vue&type=style&index=0&id=5bb80c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb80c8a",
  null
  
)

export default component.exports